import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useGlobalState } from '../../stateProvider/StateProvider';
import Button from '../../forms/Button';
import Input from '../../forms/Input';
import { addCardToAccount, removeCardFromAccount } from '../../PaymentForm';
import FormSetting from '../../layout/FormSetting';
import LoadingEllipsis from '../../forms/LoadingEllipsis';
import { userRoles } from '../../RoleProtected';
import Row from '../../layout/Row';
import { UserContexts } from '../../stateProvider/UsersContext';

const CCInfo = ({ ...props }) => {

    const { guid } = useParams();
    const context = useContext(UserContexts);
    const { CC, refreshCC } = context;

    return (
        <FormSetting
            label='Credit Card'
            controls={!context.CC ? null : [
                CC && <Button roles={userRoles.editCustomers} onClick={() => addCardToAccount(guid).then(res => refreshCC())}>{CC.onFile ? 'Update ' : 'Add '} Card</Button>,
                CC.onFile && <Button onClick={() => removeCardFromAccount(guid).then(res => refreshCC())}>Remove Card</Button>
            ]}
            localForm
        >
            {!context.CC ? <p>Loading<LoadingEllipsis /></p> : (
                CC.onFile ? (
                    <>
                        <Input
                            label='Card Type'
                            value={CC.cardType}
                            disabled
                            standalone
                        />
                        <Row wrap>
                            <Input
                                label='Masked Card Number'
                                value={CC.maskedCardNumber}
                                disabled
                                standalone
                            />
                            <Input
                                label='Expiration'
                                value={`${CC.expirationMonth}-${CC.expirationYear}`}
                                disabled
                                standalone
                            />
                        </Row>
                    </>
                ) : (
                    <div>
                        No Card on file
                    </div>
                )
            )}
        </FormSetting>
    );
}

export default CCInfo;
